import { render, staticRenderFns } from "./policiesComponent.vue?vue&type=template&id=4ab1b2de"
import script from "./policiesComponent.vue?vue&type=script&lang=js"
export * from "./policiesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports